<template>
  <div class="userindex">
    <div class="van-content">
      <van-cell-group >
        <router-link to="" class="van-cell van-hairline">
          <div class="van-cell__title">
            <span>职工评论</span>
          </div>
        </router-link>
      </van-cell-group>
      <div style="position: relative;">
        <div class="van-cell van-hairline van-field van-field--min-height">
          <div class="van-cell__value">
            <textarea style="border: 1px solid #D5D5D5;background: #F7F7F7;padding: 10px 15px" placeholder="请填写您的评论！所有个人信息将保密处理～"  rows="5" class="van-field__control" v-model="comment"></textarea>
          </div>
        </div>
        <van-cell-group style="padding: 10px 15px">
          <div style="position: relative;height: 60px">
            <van-checkbox style="position: relative;top: 12px;" v-model="checked">是否匿名</van-checkbox>
            <van-button @click="sure()" class="theme-bg" style="border-radius: 3px;position: absolute;right: 0;top: 0;">提交评论</van-button>
          </div>
        </van-cell-group>
        <div v-show="pop" class="pop">
          <img src="/static/images/success.png" >
          <p>恭喜您，评论提交成功!</p>
          <button class="theme-bg" @click="successOr">再次评论</button>
        </div>
      </div>
      <van-cell-group style="margin-top: 8px" >
        <router-link style="border-bottom: 1px solid #e5e5e5" to="" class="van-cell van-hairline">
          <div class="van-cell__title">
            <span>推荐评论</span>
          </div>
        </router-link>
        <div v-if="datas!=''&& datas!=undefined" v-for="(items,index) in datas">
          <van-row class="listCont" style="line-height: 42px;overflow: hidden">
            <van-col style="margin-right: 10px" >
              <img :src=" items.anonymous == 1||items.user_icon==null? '/static/images/userheaderimg.png' : items.user_icon" onerror="src='/static/images/userheaderimg.png'" >
            </van-col>
            <van-col span="14" >{{ items.anonymous == 1?'匿名':items.name}}</van-col>
            <van-col style="float: right">{{items.add_time}}</van-col>
          </van-row>
          <van-row class="listCont" style="line-height: 20px;overflow: hidden;border-bottom: 1px solid #F1F2F4;padding-top: 0">
            <van-col  span="24">
              {{items.content}}
            </van-col>
          </van-row>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
  export default {
    name: "index",
    props:['configData'],
    data () {
      return {
        datas:'',
        checked:false,
        pop:false,
        comment:'',
      }
    },
    methods:{
      goBack: function () {
        history.back(-1);
      },
      getDatas:function () {
        //这是2018/8/20添加的
        function uncodeUtf16(str){
          var reg = /\&#.*?;/g;
          var result = str.replace(reg,function(char){
              var H,L,code;
              if(char.length == 9 ){
                  code = parseInt(char.match(/[0-9]+/g));
                  H = Math.floor((code-0x10000) / 0x400)+0xD800;
                  L = (code - 0x10000) % 0x400 + 0xDC00;
                  return unescape("%u"+H.toString(16)+"%u"+L.toString(16));
              }else{
                  return char;
              }
          });
          return result;
      }
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Comment/index ', {}, res => {
          this.datas = res.data.data
          for(let i=0;i<this.datas.length;i++){
            this.datas[i].content=uncodeUtf16(this.datas[i].content)
          }
        })
      },
      successOr:function () {
          this.pop=!this.pop;
      },
      sure:function () {
        var isUser = localStorage.getItem("BLHuser")
        var moren=0;
        if(this.checked == true){
          moren = 1
        }else{
          moren = 0
        }
//          //这是2018/8/20添加的
//         function utf16toEntities(str) { 
//         var patt=/[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则 
//         str = str.replace(patt, function(char){ 
//                 var H, L, code; 
//                 if (char.length===2) { 
//                     H = char.charCodeAt(0); // 取出高位 
//                     L = char.charCodeAt(1); // 取出低位 
//                     code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00; // 转换算法 
//                     return "&#" + code + ";"; 
//                 } else { 
//                     return char; 
//                 } 
//             }); 
//         return str; 
//         }
// var comments=utf16toEntities(unescape(this.comment))
        this.$api.post('WebApi/Member/Comment/comment', {token:isUser,anonymous:moren,comment:this.comment}, res => {
          console.log(res)
          if(res.data.errCode == '0000') {
            this.comment = '';
            this.getDatas
            this.pop=!this.pop;
            checked=false;
//            this.$toast(res.data.desc);
          }else{
            this.$toast(res.data.desc);
          }
        })

      }
    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
  .userindex{
    .van-card__title{
      font-size: 16px;
    }
    .van-card__row describe{
      font-size: 14px;
    }
    .van-content{
      padding-top: 0;
    }
    .userbanner{
      height: 190px;
      position: relative;
      .userbox{
        padding-top: 45px;
        text-align: center;
        .vipname{
          background: #fb4141;
          padding: 4px 6px;
          border-radius: 6px;
          margin-right: 7px;
        }
        .name{
          font-size: 2rem;
        }
        .vipjif{
          margin-top: 5px;
          font-size: 1.6rem;
          color: #fff;
        }
        img{
          width: 70px;
          height: 70px;
          vertical-align: top;
          margin-right: 5px;
          border-radius: 50%;
        }
        .userInfo{
          display: inline-block;
          padding-top: 9px;
          p{
            color: #fff;
          }
        }
        .userInfo.will{
          padding-top: 0px;
          display: inline-block;
          p{
            color: #fff;
          }
        }
      }
      .signintag{
        background: #fa2924;
        width: 60px;
        display: inline-block;
        position: absolute;
        z-index: 1;
        right: 0;
        margin-top: 40px;
        overflow: hidden;
        border-radius: 16px 0 0 16px;
        box-shadow: 0px 1px 6px -1px #333;
      }

    }
    .van-cell:not(:last-child)::after{
      left: 0;
    }
    .userOrder{
      position: relative;
    }
    .van-cell-group,.van-cell{
      background: #fff;
    }
    .ordercell{
      img{
        width: 25px;
        height: auto;
        margin-bottom: 5px;
      }
    }
    .van-cell-group{
      .van-cell__title{
        img{
          width: 30px;
          margin-right: 5px;
        }
      }
    }

    .van-cell-group {
      margin-bottom: 0px;
      border-bottom: 1px solid #EEEEEE;
    }
    .describe{
      height: 40px;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp:2;
      overflow: hidden;
    }
    .van-card__thumb {
      top: 5px;
      left: 15px;
      width: 30px;
      height: 30px;
      position: absolute;
    }
    .van-card__content{
      height: 30px;
    }
    .listCont{
      img{
        width: 42px;
        height: 42px;
        border-radius: 50%;
      }
      padding: 10px 15px;
    }
    .van-cell:not(:last-child)::after {
       border-bottom-width: 0px;
    }
    .pop{
      text-align: center;
      width: 100%;
      height: 100%;
      position: absolute;
      top:0;
      left: 0;
      background: #fff;
      img{
        width: 80px;
        height: 80px;
        margin: 30px 10px 15px 10px;
      }
      p{
        font-size: 16px;
        margin-bottom: 25px;
      }
      button{
        padding: 10px 15px;
        font-size: 16px;
        border-radius: 3px;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/user/do/pingjia.vue